module.exports = __webpack_public_path__ + "vue/img/01.662731f6.png";